import { Injectable } from '@angular/core';
import { some, isString } from 'lodash';
@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  constructor() {}

  permissionList: any;

  // Ésta función devuelve si hay un permiso específico en el conjunto de permisos de un usuario
  hasPermission(permission, usuario) {
    // siempre vamos a recalcular el conjunto de permisos ya que el usuario puede cambiar
    // podría mejorarse este recalculo si se observasen mejor los cambios del usuario
    this.permissionList = [];
    if (usuario !== undefined && usuario.groups) {
      usuario.groups.map(grupo => {
        this.permissionList = this.permissionList.concat(grupo.roles);
      });
    }
    permission = permission.trim();
    return some(this.permissionList, function(item) {
      if (isString(item)) {
        return item.trim() === permission;
      }
    });
  }
}
